import React, { useCallback } from 'react';
import { Checkbox } from '@pwc/appkit-react/lib/Checkbox';

import { CustomReportRowParams } from './customReportRowParams.component';
import { CustomReportDefinition, ReportDefinition } from '../../shared/types/batchReports';
import { ParamValues } from '../../shared/types/customReports';

type ReportRowProps = {
  reportName: string,
  reportType: string,
  reportDefinition: ReportDefinition,
  reportParamValues: ParamValues,
  isIncludedInExport: boolean,
  updateReportParamValues: (itemName: string, newParameters: ParamValues) => void
  updateIncludedInExport: (itemName: string, newParameters: boolean) => void,
  archivalFlag: boolean,
  restrictBatchDefaults: boolean,
  userRole:string,
  editable:boolean
};

type ParamsSectionProps = {
  reportType: string,
  reportDefinition: ReportDefinition,
  reportParamValues: ParamValues,
  updateReportParamValues: (itemName: string, newParameters: ParamValues) => void,
  archivalFlag: boolean,
  restrictBatchDefaults: boolean,
  userRole:string,
  editable:boolean

}

const renderParamsSection = ({
  reportDefinition,
  reportParamValues,
  updateReportParamValues,
  archivalFlag,
  restrictBatchDefaults,
  userRole,
  editable,
}: ParamsSectionProps) => (
  <CustomReportRowParams
    reportDefinition={reportDefinition as CustomReportDefinition}
    reportParamValues={reportParamValues}
    updateReportParamValues={updateReportParamValues}
    archivalFlag={archivalFlag}
    restrictBatchDefaults={restrictBatchDefaults}
    userRole={userRole}
    editable={editable}

  />);


export const CustomReportRow: React.FC<ReportRowProps> = ({
  reportName,
  reportType,
  reportDefinition,
  reportParamValues,
  isIncludedInExport,
  updateReportParamValues,
  updateIncludedInExport,
  archivalFlag,
  restrictBatchDefaults,
  userRole,
  editable,
}: ReportRowProps) => {
  const onCheckboxClick = useCallback(() => {
    updateIncludedInExport(reportDefinition.reportSetId, !isIncludedInExport);
  }, [
    updateIncludedInExport,
    reportDefinition,
    isIncludedInExport,
  ]);

  return (
    <div className="row no-gutters page-content-container">
      <div className="row no-gutters batch-report-name-header">
        <div className="batch-report-name-checkbox">
          <Checkbox
            onChange={onCheckboxClick}
            checked={isIncludedInExport}
            disabled={restrictBatchDefaults}
          >
            {reportName}
          </Checkbox>
        </div>
      </div>
      <div className="no-gutters batch-report-params-container">
        {
          renderParamsSection({
            reportType,
            reportDefinition,
            reportParamValues,
            updateReportParamValues,
            archivalFlag,
            restrictBatchDefaults,
            userRole,
            editable,
          })
        }
      </div>
    </div>
  );
};
